import { Injectable } from '@angular/core';

export class EnumHelper {

  constructor() { }
  static isEnumValue<T extends Record<string, string | number>>(
    enumObj: T,
    value: string | number
  ): value is T[keyof T] {
    return Object.values(enumObj).includes(value as T[keyof T]);
  }
}
